// 業種マスタデータ (iCd)
// Generated from API1.13_20240325 04_業種マスタ
export const industryData = [
  {
    label: '金融',
    igCd: 'IG008',
    options: [
      { label: '銀行・信託銀行', value: 'I0034' },
      { label: '信用金庫・組合', value: 'I0063' },
      { label: '証券', value: 'I0035' },
      { label: '投資銀行', value: 'I0036' },
      { label: 'アセットマネジメント', value: 'I0037' },
      { label: 'プライベートエクイティ・ファンド', value: 'I0038' },
      { label: '不動産ファンド', value: 'I0039' },
      { label: 'ベンチャーキャピタル', value: 'I0040' },
      { label: 'クレジット・信販', value: 'I0043' },
      { label: '政府系金融機関', value: 'I0044' },
      { label: 'その他', value: 'I0045' }
    ]
  },
  {
    label: '保険',
    igCd: 'IG013',
    options: [
      { label: '生命保険', value: 'I0041' },
      { label: '損害保険', value: 'I0042' },
      { label: 'その他', value: 'I0064' }
    ]
  },
  {
    label: '不動産',
    igCd: 'IG014',
    options: [
      { label: 'デベロッパー', value: 'I0046' },
      { label: '不動産仲介', value: 'I0065' },
      { label: '不動産管理', value: 'I0066' },
      { label: 'その他', value: 'I0050' }
    ]
  },
  {
    label: '建設',
    igCd: 'IG009',
    options: [
      { label: '建設・建築・土木', value: 'I0047' },
      { label: '設備・電気', value: 'I0067' },
      { label: '住宅設備・ハウスメーカー', value: 'I0048' },
      { label: 'プラント・エンジニアリング', value: 'I0049' },
      { label: '内装・リフォーム・インテリア', value: 'I0068' },
      { label: 'その他', value: 'I0069' }
    ]
  },
  {
    label: 'コンサルティング',
    igCd: 'IG005',
    options: [
      { label: 'コンサルティング', value: 'I0025' },
      { label: 'シンクタンク', value: 'I0070' },
      { label: 'リサーチ', value: 'I0071' },
      { label: 'その他', value: 'I0028' }
    ]
  },
  {
    label: '士業',
    igCd: 'IG015',
    options: [
      { label: '監査・税理士法人', value: 'I0026' },
      { label: '法律事務所', value: 'I0027' },
      { label: 'その他', value: 'I0072' }
    ]
  },
  {
    label: 'IT・インターネット',
    igCd: 'IG001',
    options: [
      { label: 'インターネットサービス', value: 'I0001' },
      { label: 'デジタルマーケティング', value: 'I0073' },
      { label: 'SIer', value: 'I0002' },
      { label: 'ソフトウエア', value: 'I0003' },
      { label: 'ハードウエア', value: 'I0004' },
      { label: '通信・キャリア', value: 'I0005' },
      { label: 'その他', value: 'I0006' }
    ]
  },
  {
    label: 'メーカー',
    igCd: 'IG002',
    options: [
      { label: '電気・電子', value: 'I0007' },
      { label: '半導体', value: 'I0008' },
      { label: '機械', value: 'I0009' },
      { label: '精密・計測機器', value: 'I0010' },
      { label: '自動車・自動車部品', value: 'I0011' },
      { label: '化学・石油', value: 'I0012' },
      { label: 'バイオ', value: 'I0074' },
      { label: '素材', value: 'I0075' },
      { label: '食品・飲料', value: 'I0013' },
      { label: '日用品', value: 'I0014' },
      { label: '化粧品', value: 'I0076' },
      { label: 'アパレル・ファッション', value: 'I0015' },
      { label: 'その他', value: 'I0016' }
    ]
  },
  {
    label: '商社',
    igCd: 'IG003',
    options: [
      { label: '総合商社', value: 'I0017' },
      { label: '専門商社', value: 'I0018' }
    ]
  },
  {
    label: '流通・小売',
    igCd: 'IG004',
    options: [
      { label: '流通', value: 'I0019' },
      { label: '小売', value: 'I0020' },
      { label: 'その他', value: 'I0024' }
    ]
  },
  {
    label: 'サービス',
    igCd: 'IG016',
    options: [
      { label: '人材紹介・人材派遣', value: 'I0077' },
      { label: 'アウトソーシング・コールセンター', value: 'I0078' },
      { label: '旅行・観光', value: 'I0079' },
      { label: 'ホテル', value: 'I0080' },
      { label: 'アミューズメント', value: 'I0022' },
      { label: '福祉・介護', value: 'I0081' },
      { label: '外食', value: 'I0021' },
      { label: 'ブライダル', value: 'I0082' },
      { label: 'その他', value: 'I0023' }
    ]
  },
  {
    label: 'メディカル',
    igCd: 'IG010',
    options: [
      { label: '医薬品メーカー', value: 'I0051' },
      { label: '医療機器メーカー', value: 'I0052' },
      { label: '医薬品卸', value: 'I0083' },
      { label: '医療機器卸', value: 'I0053' },
      { label: '病院・クリニック', value: 'I0054' },
      { label: '大学・研究施設', value: 'I0084' },
      { label: 'CRO', value: 'I0055' },
      { label: '臨床検査機器・診断薬', value: 'I0085' },
      { label: 'ドラッグストア・調剤薬局', value: 'I0086' },
      { label: '再生医療・バイオベンチャー', value: 'I0087' },
      { label: 'その他', value: 'I0056' }
    ]
  },
  {
    label: 'マスコミ・メディア',
    igCd: 'IG006',
    options: [
      { label: '広告・PR', value: 'I0029' },
      { label: 'テレビ・放送・映像・音響', value: 'I0030' },
      { label: '新聞・出版', value: 'I0088' },
      { label: '印刷', value: 'I0089' },
      { label: 'その他', value: 'I0090' }
    ]
  },
  {
    label: 'エンターテインメント',
    igCd: 'IG007',
    options: [
      { label: '音楽', value: 'I0091' },
      { label: '映画', value: 'I0031' },
      { label: 'ゲーム', value: 'I0032' },
      { label: 'その他', value: 'I0033' }
    ]
  },
  {
    label: '運輸・交通',
    igCd: 'IG017',
    options: [
      { label: '海運', value: 'I0092' },
      { label: '鉄道', value: 'I0093' },
      { label: '陸運', value: 'I0094' },
      { label: '空輸', value: 'I0095' },
      { label: '空港', value: 'I0096' },
      { label: 'その他', value: 'I0097' }
    ]
  },
  {
    label: '物流・倉庫',
    igCd: 'IG018',
    options: [
      { label: '物流', value: 'I0098' },
      { label: '倉庫', value: 'I0099' },
      { label: 'その他', value: 'I0100' }
    ]
  },
  {
    label: 'エネルギー',
    igCd: 'IG011',
    options: [
      { label: '電力・ガス・水道', value: 'I0057' },
      { label: '石油', value: 'I0101' },
      { label: 'エネルギー', value: 'I0058' },
      { label: 'その他', value: 'I0059' }
    ]
  },
  {
    label: 'その他（教育・官公庁）など',
    igCd: 'IG012',
    options: [
      { label: '教育', value: 'I0060' },
      { label: '官公庁', value: 'I0061' },
      { label: '自治体', value: 'I0102' },
      { label: '農林・水産', value: 'I0103' },
      { label: 'その他', value: 'I0062' }
    ]
  }
]
